import React, { useEffect, useMemo, useState } from 'react';
import { Button, Checkbox, DatePicker, Input, List, Radio, Space } from 'antd';
import {CaretDownFilled, DownOutlined, SearchOutlined} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import serviceHelper from '../../../../helpers/functions/service.helper';
import FilterBullet from '../../../../helpers/components/filter_bullet';
import dayjs from 'dayjs';
import MerchantSettlementModal from "./settlement_modal";
import merchantSettlementService from "../../../../services/ewallet_integration/merchant_settlement.service";
import moment from "moment/moment";
import globalHelper from "../../../../helpers/functions/global.helper";
import MerchantSettlementList from "./merchant_settlement_list";

const { RangePicker } = DatePicker;
const MerchantSettlementLayout = ({ merchant = {}, setRefresh, refresh}) => {
    const { innerWidth } = window;
    const [settlementModal, setSettlementModal] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);
    const [state, setState] = useState({
        loading : false,
        merchants : [],
        all_merchants: [],
    })
    const [filter, setFilter] = useState({
        start_date : '',
        end_date : '',
        search : '',
    })
    const [timer, setTimer] = useState(null);

    const doneTyping = async (input) => {
        clearTimeout(timer);
        const newTimer = setTimeout(() => {
            setFilter(filter => ({ ...filter, search: input, }));
        }, 300);
        setTimer(newTimer);
    }

    // change date
    const changeDate = (key1, key2, date) => {
        if(date){
            const start_date = dayjs(date[0])?.format("YYYY-MM-DD");
            const end_date = dayjs(date[1])?.format("YYYY-MM-DD");
            setFilter(filter => ({...filter, [key1] : start_date, [key2] : end_date}));
        }else{
            setFilter(filter => ({...filter, [key1] : null, [key2] : null}));
        }
    }


    const initialize = async () => {
        setState(state => ({...state, loading : true, }));


        const merchantResponse = await merchantSettlementService?.merchants({ has_balance: true });
        const { merchants, } = merchantResponse.data;

        const merchantListingResponse = await merchantSettlementService.merchants();
        const { merchants: all_merchants, } = merchantListingResponse.data;
        setRefresh(false);
        setState(state => ({...state, loading : false, merchants: merchants, all_merchants: all_merchants }));
    }

    const exportExcel = async () => {
        setExportLoading(true);
        const { search,  start_date, end_date, } = filter;
        const response = await merchantSettlementService?.settlementListingByMerchantId(merchant?.merchant_id,{
            // filter
            search,
            start_date : start_date,
            end_date : end_date,

            is_export: true,
            // order
            order : "created_at",
            order_position : 'DESC',
        });

        const { rows } = response?.data;

        const data = rows?.map((obj, index) => {
            const { merchant, activity, created_at, payment_amount, currency } = obj ?? {};
            const count = (index + 1);
            return {
                "No" : count,
                "Merchant" : merchant?.name,
                "Transaction No." : activity?.transaction_no,
                "Status" :  activity?.activity_status?.name,
                "Date" : moment(created_at)?.isValid() ? moment(created_at)?.format("DD MMM YYYY HH:mm") : "",
                "Amount" : activity?.melon_amount,
                "Payment Amt." : `${currency?.code}${payment_amount}`,
            }
        });
        globalHelper.exportToExcel({
            data : data,
            name : `merchant_settlements_${moment()?.format("YYYYMMDD")}`,
        });

        setExportLoading(false);
    }

    useEffect(() => {
        initialize();
    }, [])


    return (
        <>
            <div className='mobile-padding-12'>
                <div>
                    <Input
                        onChange={(e) => doneTyping(e.target.value)}
                        name="search"
                        defaultValue={filter?.search}
                        prefix={<SearchOutlined style={{color :'var(--secondary-text-color)'}} />}
                        placeholder='Search'
                        style={{minWidth: '100%',}}
                        allowClear
                        // {...(errors?.find(x => x?.type === 'search_length') && ({ status : 'warning', }))}
                    />
                    <div style={{display: 'flex', alignItems: 'center', marginTop: 12, gap: 8,}}>
                        <div className='filter-panel' style={{textAlign: 'start'}}>
                            <Space direction={innerWidth > 768 ? 'horizontal' : 'vertical'}>
                                <FilterBullet
                                    popover={
                                        <>
                                            <div>
                                                <RangePicker
                                                    {...(filter?.start_date && filter?.end_date) && ({defaultValue: [dayjs(filter?.start_date), dayjs(filter?.end_date)]})}
                                                    onChange={(e) => changeDate('start_date', 'end_date', e)}
                                                    format={"YYYY-MM-DD"}
                                                />
                                            </div>
                                        </>
                                    }
                                >
                                    <div>
                                        <Space>
                                            <div>
                                                <span>Issue Date
                                                    <span style={{
                                                        fontSize: 12,
                                                        fontWeight: 500,
                                                        color: 'var(--secondary-text-color)'
                                                    }}>
                                                        {filter?.start_date && filter?.end_date && `: ${filter?.start_date}-${filter?.end_date}`}
                                                    </span>
                                                </span>
                                            </div>
                                            <div>
                                                <CaretDownFilled style={{color: '#a0aec0'}}/>
                                            </div>
                                        </Space>
                                    </div>
                                </FilterBullet>
                            </Space>
                        </div>

                        <div style={{marginLeft: 'auto'}}>
                            <Space>
                                <Button loading={exportLoading} onClick={() => exportExcel()}>
                                    Export
                                </Button>
                                <Button
                                    type="primary"
                                    onClick={() => setSettlementModal(true)}
                                >
                                    Create Settlement
                                </Button>
                            </Space>
                        </div>

                    </div>
                </div>

                <div style={{marginTop: 12,}}>
                    <MerchantSettlementList filter={filter} merchant={merchant} setRefresh={setRefresh} refresh={refresh}/>
                </div>
            </div>

            <MerchantSettlementModal
                visible={settlementModal}
                onClose={() => setSettlementModal(false)}
                setRefresh={setRefresh}
                merchant={merchant}
            />
        </>
    );
}

export default MerchantSettlementLayout;